import { useState, useEffect } from 'react';
import { Tabs, Space } from 'antd';
import type { TabsProps } from 'antd';
import { Button, Form } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import axios from 'axios';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import { Box, Typography } from '@mui/material';
import MDemandeAutorisation from '../../../../Models/MDemandeAutorisation' //'../../../Models/Classes/MDemandeAutorisation';
import formatDate from '../../../../Functions/Traitement/fomatDate' //'../../../function/FormDate';
import ReformatDate from '../../../../Functions/Traitement/ReformatDate' //'../../../function/ReformDate';
import DataPeriod1 from "../../../../Functions/Traitement/DataPeriodAuto" //'../../../../Models/Types/DataPeriodAuto';
import { Spin } from 'antd';
import { ColumnsType } from 'antd/es/table';
import Table from '../../../TableResizable';
import Swal from 'sweetalert2';
import { Person, SettingsSuggest } from '@mui/icons-material';
import Demand from '../../../../Models/MDemandeAutorisation';
import SweetAlert from "sweetalert2";
import { Crypter } from '../../../../Functions/Security/Crypter';
import Data from '../../../../Data/Data.json'
import Format from '../../../../Functions/Traitement/Format';
import Tab5 from './Tabvalauto';
import Utilisateur from '../../../../Models/Utilisateur';
import { useNavigate } from 'react-router-dom';
import DataType from "../../../../Functions/Traitement/DataPeriodAuto";
import ParamsPicklist from "../../../../Types/ParamsPicklist"

import SearInputModal from "../../../SearchModal" //"../../../Composants/SearchModal";
import SearInputG from "../../../SearchInput" //"../../../Composants/SearchInput";
import InputForm from "../../../InputT"


import { useTranslation } from "react-i18next";



// DECLARATION DES COLONNES DU TABLEAU
const columns: ColumnsType<DataType> = [
    {
        title: 'Numéro découvert',
        dataIndex: 'NUMCRD',

    },
    {
        title: 'ID client',
        dataIndex: 'NUMCLI',
    },
    {
        title: 'Nom client',
        dataIndex: 'NOMCLI',
    },
    {
        title: 'Nom service',
        dataIndex: 'SERVGE',
    },
    {
        title: 'Nature découvert',
        dataIndex: 'NATCRD',
    },
    {
        title: 'Montant',
        dataIndex: 'MNTAUT',
    },
    {
        title: 'Date effet',
        dataIndex: 'DATEFF',
    },
    {
        title: 'Date limite',
        dataIndex: 'DATEFIN',
    }
];

let searchAutorisation: ParamsPicklist = { CodeAgence: '', Table: "AUTORISATION", Colonne1: "NUMCRD", Colonne2: "NUMCLI", Colagence: '101', Choix: 22 }
let searchClient: ParamsPicklist = { CodeAgence: '', Table: "CLIENT", Colonne1: "NUMCLI", Colonne2: "NOMCLI", Colagence: '101', Choix: 22 }
let searchCompte: ParamsPicklist = { CodeAgence: '', Table: "COMPTES", Colonne1: "NUMCPT", Colonne2: "NOMCPT", Colagence: '101', Choix: 22 }
let searchDevise: ParamsPicklist = { CodeAgence: '', Table: "DEVISE", Colonne1: "CODDEV", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }
let searchNatcrd: ParamsPicklist = { CodeAgence: '', Table: "TYPEPRET", Colonne1: "TYPEPRET", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchService: ParamsPicklist = { CodeAgence: '', Table: "SERVICE", Colonne1: "CODSERV", Colonne2: "LIBELLE", Colagence: '101', Choix: 22 }
let searchCommis: ParamsPicklist = { CodeAgence: '', Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: '101', Choix: 22 }


const ValidAutor = (props: { Idnumcrd?: string }) => {

    // state de navigation
    const navigate = useNavigate();

    // USER SESSION
    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))

    // usestate 
    const [numerocrd, Setnumcrd] = useState("");

    // declaration des usestate 
    const authHeader = useAuthHeader()
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [, forceUpdate] = useState({});
    const [isSubmit, setIsSubmit] = useState(false)
    const [ajoutActve, setAjoutActif] = useState(false)
    const [enregActve, setEnregActve] = useState(false)
    const NUMCRD = window.location.pathname.split("/")[3];
    const [Pageload, setPageLoad] = useState(true);
    const [retour, setRetour] = useState(true)
    const [annul, setAnnul] = useState(false)
    const [consult, setConsult] = useState(false)


    //  HANDLE SUBMIT
    // function HandleRetour1() {
    //     setConsult(true);
    //     ConsultTab();
    // }

    // function HandleRetour2() {
    //     setConsult(true);
    //     Consultableau();
    // }

    function HandleAnnul() {
        form.resetFields();
        Consultableau();
        setSelectedRowKeys([])
    }



    const [Pageloadd, setPageLoadd] = useState(false)
    // function pour charger la page 
    if (Pageload === true) {

        if (Pageloadd == false) {
            Consultableau()
            setPageLoad(false)
            setPageLoadd(true)
        }

    }

    // function pour remplir les données du tableau 
    function Consultableau() {

        //alert("tab");
        //etat de recharge
        // localStorage.clear()
        // localStorage.setItem(Data.LocalVariable.reset, "1");

        let data1 = Crypter.encrypt('1');
        let data2 = Crypter.encrypt(Perss.codage)

        if (data1.length != 0 && data2.length != 0) {

            setLoading(true);
            let config = {
                method: 'get',
                maxBodyLength: Infinity,
                url: Data.ApiUrl.ConsultTabPeriode,
                headers: {
                    'CypherChoix': data1,
                    'CypherCodeage': data2,
                    'Authorization': authHeader(),
                    'Content-Type': 'application/json'
                },
            };


            // MAPPING DANS LE TABLEAU
            let dat: DataPeriod1[] = [];

            axios.request(config)
                .then((response) => {
                    setLoading(false);

                    //alert('one 1++' + response.data)
                    if (response.data) {


                        let datas1 = JSON.parse(Crypter.decrypt(response.data));
                        let datas = (datas1.Result);

                        datas.map((val: any, key: any) => {
                            dat.push({
                                key: key,
                                NUMCRD: val.NUMCRD,
                                NUMCLI: val.NUMCLI,
                                NOMCLI: val.NOMCLI,
                                SERVGE: val.SERVGE,
                                NATCRD: val.NATCRD,
                                MNTAUT: val.MNTAUT,
                                DATEFF: val.DATEFF,
                                DATEFIN: val.DATEFIN,
                                CPTAUT: val.CPTAUT,
                                CDETAT:val.CDETAT
                            }
                            )
                        })
                        setData(dat);

                    }
                    setLoading(false)
                })
                .catch((error) => {
                    setLoading(false);
                    console.log(error)
                    SweetAlert.fire({ title: "ErrorW", text: error, icon: "error" })
                });
        }
    }



    const [sbmit, setSbmit] = useState("")

    // function onfinish
    const Onfinish = (values: any) => {
        let Numcrd = (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "")
        //alert(Numcrd)
        if (Numcrd == null) {
            SweetAlert.fire({ title: "Warning", text: "Svp renseigner le numero de l'autorisation", icon: "warning" })
        } else {

            if (sbmit == 'Rejet') {

                SweetAlert.fire({
                    title: "REJET DECOUVERT",
                    text: "Voulez-vous Rejeter le Découvert avec Pour Réference :  " + Numcrd + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        //alert(Numcrd)
                        let data1 = Crypter.encrypt(JSON.stringify(Numcrd));
                        let data2 = Crypter.encrypt(JSON.stringify(Perss.coduti));
                        let data3 = Crypter.encrypt(JSON.stringify('004'));
                        let data4 = Crypter.encrypt(JSON.stringify(formatDate(Perss.datjour)));
                        let data5 = Crypter.encrypt(JSON.stringify(Perss.codage));

                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidationAutorisation,
                            headers: {
                                'CypherNUMCRD': data1,
                                'CypherUTIVAL': data2,
                                'Cypherchoix': data3,
                                'Cypherdatval': data4,
                                'CypherCodeage':data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };
                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {

                                    let datas1 = JSON.parse(Crypter.decrypt(response.data));
                                    let code = (datas1.Result);

                                    if (code == 'ErreurJr') {
                                        SweetAlert.fire({ title: " ", text: "Opération Impossible: Date comptable n'est pas ouverte " + code, icon: "warning" })
                                    } else if (code == 'Le meme utilisateur ne peut validé') {
                                        SweetAlert.fire({ title: " ", text: "Opération Impossible : Le meme utilisateur ne peut Rejeté" , icon: "warning" })
                                    } else if (code == 'ErreurLimite') {
                                        SweetAlert.fire({ title: " ", text: "Opération Impossible : Le montant est supérieur à la limite" + code, icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Reference Decouvert Rejeter:" + code, icon: "success" })
                                        localStorage.clear()
                                        HandleAnnul()
                                    }
                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                console.log(error)
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });

                    }
                })

            } else if (sbmit == 'valid') {

                SweetAlert.fire({
                    title: "VALIDATION DECOUVERT",
                    text: "Voulez-vous Valider le Découvert avec Pour Réference : " + Numcrd + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        //alert(Numcrd)
                        let data1 = Crypter.encrypt(JSON.stringify(Numcrd));
                        let data2 = Crypter.encrypt(JSON.stringify(Perss.coduti));
                        let data3 = Crypter.encrypt(JSON.stringify('val'));
                        let data4 = Crypter.encrypt(JSON.stringify(formatDate(Perss.datjour)));
                        let data5 = Crypter.encrypt(JSON.stringify(Perss.codage));

                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidationAutorisation,
                            headers: {
                                'CypherNUMCRD': data1,
                                'CypherUTIVAL': data2,
                                'Cypherchoix': data3,
                                'Cypherdatval': data4,
                                'CypherCodeage':data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };
                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {

                                    let datas1 = JSON.parse(Crypter.decrypt(response.data));
                                    let code = (datas1.Result);

                                    if (code == 'ErreurJr') {
                                        SweetAlert.fire({ title: " ", text: "Opération Impossible: Date comptable n'est pas ouverte ", icon: "warning" })
                                    } else if (code == 'Le meme utilisateur ne peut validé') {
                                        SweetAlert.fire({ title: " ", text: "Opération Impossible : " + code, icon: "warning" })
                                    } else if (code == 'ErreurLimite') {
                                        SweetAlert.fire({ title: " ", text: "Opération Impossible : Le montant est supérieur au reste de la limite", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Reference Decouvert Valider :" + code, icon: "success" })
                                        localStorage.clear()
                                        HandleAnnul()
                                    }

                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                console.log(error)
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });

                    }
                })
            }

        }
    }


    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })
        SweetAlert.fire({ title: "SVP veuillez Selectionner une autorisation", icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };


    //*********************************************   New Parametre *******************/

    /// fonction Consult
    function ConsultTab() {
        let Numcrd = (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FourthValueAuto) + '')) + "")

        if (Numcrd == undefined || Numcrd == null) {
            alert("mauvais traitement")
        } else {
            let data = Crypter.encrypt(Numcrd);

            if (data.length != 0) {
                setLoading(true)
                //form.resetFields()
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadAutorisation,
                    headers: {
                        'CypherNumcrd': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                };

                axios.request(config)
                    .then((response) => {
                        setLoading(false);

                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            console.log(JSON.stringify(res))
                            let Autorisation = res.Result.Table[0]

                            if (res.StatutCode == 200) {

                                form.setFieldsValue(Autorisation);

                                //form.setFieldValue('lib_NUMCRD', ReformatDate(Autorisation.lib_IDClient));
                                form.setFieldValue('DATEFF', ReformatDate(Autorisation.DATEFF));
                                form.setFieldValue('DATEFIN', ReformatDate(Autorisation.DATEFIN));
                                GetLimite()

                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    // function pour la selection du tab
    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    const [donnees, setData] = useState<DataType[]>([]);

    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);

        sessionStorage.setItem(Data.LocalVariable.FourthValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMCRD))
        ConsultTab()

    };
    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    // function Getselectcli2() {
    //     GetLimite()
    //     form.setFieldValue("MNTAUT", 0)
    // }

    function GetLimite() {

        if (form.getFieldValue("IDLIMITE") == null) {

        } else {
            let data = Crypter.encrypt(form.getFieldValue("IDLIMITE"));
            let IDLIMITE = form.getFieldValue("IDLIMITE")
            if (data.length != 0) {

                setLoading(true)

                form.setFieldValue("IDLIMITE", IDLIMITE)
                let config = {
                    method: 'get',
                    maxBodyLength: Infinity,
                    url: Data.ApiUrl.ReadLimite,
                    headers: {
                        'CypherNumordre': data,
                        'Authorization': authHeader(),
                        'Content-Type': 'application/json'
                    },
                    //data: data
                };
                axios.request(config)
                    .then((response) => {
                        setLoading(false);
                        if (response.data) {
                            const res = JSON.parse(Crypter.decrypt(response.data));
                            //console.log(JSON.stringify(res))
                            let limite = res.Result.Table[0]
                            //console.log(JSON.stringify(limite))

                            if (res.StatutCode == 200) {
                                // console.log(limite)
                                // form.setFieldsValue(limite);

                                // NivCons  MNTlimite  NUMOrdre
                                form.setFieldValue("MNTlimite", limite.MNTlimite)
                                form.setFieldValue("NivCons", limite.NivCons)
                                form.setFieldValue('datedebut', ReformatDate(limite.datedebut))
                                form.setFieldValue('Ldatefin', ReformatDate(limite.datefin))
                                form.setFieldValue("RESTANT", limite.MNTlimite - limite.NivCons)

                            }
                            else {
                                SweetAlert.fire({ title: "Warning", text: res.Message, icon: "warning" })
                            }
                        }
                        setLoading(false)
                    })
                    .catch((error) => {
                        setLoading(false);
                        console.log(error)
                        SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                    });
            }
        }
    }

    //********************************************** New tab **************************/
    const { t, i18n } = useTranslation();
    let InfoDemandeAutorisation = {
        numauto: t("FormDemandeAutorisation.numauto"),
        idclt: t("FormDemandeAutorisation.idclt"),
        numcpte: t("FormDemandeAutorisation.numcpte"),
        natcre: t("FormDemandeAutorisation.natcre"),
        libdevi: t("FormDemandeAutorisation.libdevi"),
        Libserv: t("FormDemandeAutorisation.Libserv"),
        libmtant: t("FormDemandeAutorisation.libmtant"),
        libperiod: t("FormDemandeAutorisation.libperiod"),
        libgaranti: t("FormDemandeAutorisation.libgaranti"),
        libfrais: t("FormDemandeAutorisation.libfrais"),
        librenew1: t("FormDemandeAutorisation.librenew1"),
        librenew2: t("FormDemandeAutorisation.librenew2"),
        libperiodj: t("FormDemandeAutorisation.libperiodj"),
        libcmd1: t("FormDemandeAutorisation.libcmd1"),
        libcmd2: t("FormDemandeAutorisation.libcmd2"),
        libcmb3: t("FormDemandeAutorisation.libcmb3"),
        libmtant1: t("FormDemandeAutorisation.libmtant1"),
        libmtant2: t("FormDemandeAutorisation.libmtant2"),
        libmtant3: t("FormDemandeAutorisation.libmtant3")
    };

    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '5',
            label: (
                <span id='Tab'>
                    <UserOutlined />
                    Validation découvert
                </span>
            ),
            children: <>

                <div className='tabItem' >

                    <div style={{ display: 'block flow' }}  >
                        <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >

                            <legend> Formulaire de validation </legend>
                            <Box fontStyle="inherit" >
                                <Box>

                                    <fieldset className="bordure1" style={{ marginTop: -10 }}>
                                        <Box style={{ display: 'flex', marginTop: 0, width: '100%' }}>
                                            <Box style={{ width: '100%' }}>
                                                <Box style={{ marginTop: -8 }}>
                                                    <SearInputG width={6} dissabledCode={true} notRequired Titre=" Recherche" label={InfoDemandeAutorisation.numauto} name="NUMCRD" Taille1={'100%'} Taille2={0} Parametre={searchAutorisation} /* etat={setSearchGlobal} */ form={form} />
                                                </Box>
                                                <Box style={{ marginTop: -10 }}>
                                                    <SearInputModal width={6} Titre="Recherche" label={InfoDemandeAutorisation.idclt} name="NUMCLI" Taille1={'100%'} Taille2={'100%'}  Parametre={searchClient} form={form} />
                                                </Box>
                                                <Box style={{ marginTop: -10, marginBottom: -5 }}>
                                                    <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.numcpte} name="CPTAUT" Taille1={'100%'} Taille2={'100%'} Parametre={searchCompte} form={form} />
                                                </Box>
                                            </Box>
                                            <Box style={{ width: '100%' }}>
                                                <Box style={{ marginTop: -8 }}>
                                                    <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.natcre} name="NATCRD" Taille1={'100%'} Taille2={'100%'} Parametre={searchNatcrd} form={form} />
                                                </Box>
                                                {/* <Box style={{ marginTop: -10 }}>
                                                        <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.Libserv} name="SERVGE" Taille1={'100%'} Taille2={'100%'} Parametre={searchService} form={form} />
                                                    </Box> */}
                                                <Box style={{ marginTop: -10, marginBottom: -5 }}>
                                                    <SearInputModal width={6} Titre=" Recherche" label={InfoDemandeAutorisation.libdevi} defaultCode="XAF" defaultLibelle="FRANC CFA BEAC" name="DEVAUT" Taille1={'100%'} Taille2={'100%'} Parametre={searchDevise} form={form} />
                                                </Box>
                                            </Box>

                                        </Box>
                                    </fieldset>

                                    <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                        <Box style={{ display: 'flex', marginTop: 5, width: '100%' }}>
                                            <Box style={{ marginTop: -10, marginBottom: -7 }}>
                                                <SearInputModal width={0} Titre=" Recherche" label={'Limite Associée'} name="IDLIMITE" Taille1={'100%'} Taille2={0} form={form} />
                                            </Box>
                                            <Box style={{ marginLeft: -5, marginTop: -10, width: '24%', marginBottom: -7 }}>
                                                <InputForm disabled={true} label={'Montant limite'} name="MNTlimite" type="string" />
                                            </Box>
                                            <Box style={{ marginLeft: -5, marginTop: -10, width: '21%', marginBottom: -7 }} >
                                                <InputForm disabled={true} label={'Nivcons'} name="NivCons" type="number" />
                                            </Box>
                                            <Box style={{ marginLeft: -5, marginTop: -10, width: '21%', marginBottom: -7 }} >
                                                <InputForm disabled={true} label={'RESTANT'} name="RESTANT" type="number" />
                                            </Box>
                                        </Box>
                                    </fieldset>
                                </Box>

                                <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                    <Box style={{ display: 'flex' }}>
                                        <Box style={{ width: '21%', marginTop: -5, marginBottom: -5 }}>
                                            <InputForm label="Montant" width={10} name="MNTAUT" type="number" />
                                        </Box>
                                        <Box style={{ marginTop: -5, marginBottom: -5, width: '85%' }}>
                                            <InputForm width={3} label={InfoDemandeAutorisation.libgaranti} name="GARANT" type="string" />
                                        </Box>
                                    </Box>
                                </fieldset>

                                <fieldset className="bordure1" style={{ marginTop: 0 }}>
                                    <Box style={{ display: 'flex', marginTop: -8 }}>
                                        <Box style={{ marginBottom: -7, width: '25%' }}>
                                            <InputForm label="date effet" defaultValue={Perss.datjour} width={0} name="DATEFF" type="date" />
                                        </Box>
                                        <Box style={{ marginBottom: -7, width: '25%' }}>
                                            <InputForm label="date fin" defaultValue={Perss.datjour} name="DATEFIN" type="date" width={0} />
                                        </Box>
                                        <Box style={{ marginBottom: -7, width: '25%' }}>
                                            <InputForm disabled={true} label="Date limite debut" width={0} name="datedebut" type="date" />
                                        </Box>
                                        <Box style={{ marginBottom: -7, width: '25%' }}>
                                            <InputForm disabled={true} label="Date limite fin" name="Ldatefin" type="date" width={0} />
                                        </Box>
                                       </Box>
                                 </fieldset>
                            </Box>

                            <legend> Listes des découverts en attentes de validation </legend>
                            <Box className='border'  style={{ marginTop: -15, marginBottom: 20 }}  fontStyle="inherit" >

                                <Spin spinning={loading}>
                                    <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} style={{ textAlign: "center", width: '100%' }} columns={columns} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                </Spin>
                            </Box>

                        </Box>
                    </div>
                </div >


            </>
        },
    ];

    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'><b> {window.location.pathname}</b></Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }} >
                <Form disabled={!ajoutActve} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={Onfinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>

                                <Button size='large' className='bt_add' disabled={annul} onClick={() => { setSbmit('valid') }} type="ghost" htmlType="submit" block  >
                                    Valider
                                </Button>
                                <Button size='large' className='bt_add' disabled={annul} onClick={() => { setSbmit('Rejet') }} type="ghost" htmlType="submit" block  >
                                    Rejeter
                                </Button>
                                <Button size='large' className='bt_add' disabled={annul} onClick={() => { setPageLoad(true); HandleAnnul() }} type="ghost" block>
                                    Actualiser
                                </Button>

                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div >
                            <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                        </div>
                        <div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );



}

export default ValidAutor;
